import React, { useEffect, useState } from "react";
import { list, add, edit, detail } from "../../../center/services/wallet.services";
import { LOADER_TIMEOUT_TIME, ROLE, SORT_A, SORT_D, SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { Field, Form, Formik, useFormik } from "formik";
import { useValidationSchemas } from "../../validator/validation";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter, formatDateNew, formateDate, getUser, globalLoader, handleOffcanvasScroll, handleServerValidations, removeSpecialCharacter, TrimText } from "../../../../utils/commonfunction";
import CustomError from "../../../../utils/customError";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DatePicker, Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import { centerProfileDetails } from "../../../center/services/profile.services";
import CustomPagination from "../../../admin/common/custompagination";
import { createPrescription, getAppointments, getPrescription, listAppointments, sendOTP, verifyOTP, detail as PatientDetails } from "../../services/patient.services";
import trash from "../../../../assets/center/images/trash.svg";
import OtpInput from "react-otp-input";
import { getAllMedicine } from "../../../admin/services/medicine.services";
import RecordNotFound from "../../shared/recordNotFound";

export default function ConsultationHistory() {
    const navigate = useNavigate()
    const location = useLocation();
    const params = useParams();
    const { t } = useTranslation();
    const [List, setList] = useState([]);
    const { walletValidationSchema, editScheduleValidationSchema } = useValidationSchemas();
    const [refreshList, setRefreshList] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);
    const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
    const [openWithHeaderView, setOpenWithHeaderView] = useState(false);
    const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
    const [globalSearch, setGlobalSearch] = useState("");
    const [search, setSearch] = useState({});
    const [loader, setLoader] = useState(true);
    const [scheduleDetail, setScheduleDetail] = useState({});
    const [page, setPage] = useState(1);
    const [offset, setOffsetPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [itemPerPage] = useState(10);
    const [sortConfig, setSortConfig] = useState({ column: 'appointment_date', order: SORT_D });
    const [sortHistoryConfig, setSortHistoryConfig] = useState({ column: 'date', order: SORT_D });
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
    const [walletBalance, setWalletBalance] = useState();
    const [activeTab, setActiveTab] = useState("upcoming");
    const [consultationHistoryDetails, setConsultationHistoryDetails] = useState({});
    const [patientHistory, setPatientHistory] = useState({});
    const [openWithHeaderVerifyOTP, setOpenWithHeaderVerifyOTP] = useState(false);
    const { otpValidationSchema } = useValidationSchemas();
    const [medicalHistoryData, setMedicalHistoryData] = useState([]);
    const [resendDisabled, setResendDisabled] = useState(false);
    const [counter, setCounter] = useState(0);
    const [medicineData, setMedicineData] = useState([]);


    useEffect(() => {
        setLoader(true);
        const formData = new FormData();
        if (Object.keys(search).length) {
            formData.append("search", JSON.stringify(search));
        }
        formData.append("global_search", globalSearch);
        let page = params.page;
        if (globalSearch) {
            if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
                page = 1;
            }
            setPage(page);
        }
        formData.append("page", page);
        formData.append("per_page", itemPerPage);
        
        formData.append("isCancledIncluded", true);
        if (activeTab === "upcoming") {
            formData.append("isUpcomingAppointments", true);
            formData.append("sort", JSON.stringify({ column: 'appointment_date', order: SORT_A }));
        } else {
            formData.append("isUpcomingAppointments", false);
            formData.append("sort", JSON.stringify({ column: 'appointment_date', order: SORT_D }));
        }

        listAppointments(formData)
            .then((data) => {
                if (data && data.data) {
                    setList(data.data.list || []);
                    setPage(data.data.page);
                    navigate(`/doctor/consultation-history/${data.data.page}`);
                    setOffsetPage(data.data.offset);
                    setTotalRecords(data.data.total_records || 0);
                } else {
                    setList([]);
                    setOffsetPage(0);
                    setTotalRecords(0);
                }
                setPrevGlobalSearch(globalSearch);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                console.log("error ====> ", error);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            });
    }, [search, refreshList, globalSearch, params.page, sortConfig, activeTab]);

    const addForm = useFormik({
        initialValues: {
            patient_id: "",
            symptoms: "",
            diagnosis_notes: "",
            medications: [{ medicine_id: "", dosage: "", frequency: "" }],
        },
        validationSchema: walletValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            const formData = new FormData();
            formData.append("appointment_id", consultationHistoryDetails?._id);
            formData.append("patient_id", consultationHistoryDetails?.patient_id);
            formData.append("symptoms", values.symptoms);
            formData.append("diagnosis_notes", values.diagnosis_notes);
            formData.append("medicines", JSON.stringify(values.medications));
            setAddSubmissionLoader(true);
            createPrescription(formData)
                .then((response) => {
                    setAddSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeader(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setAddSubmissionLoader(false);
                    console.error("Error updating Prescription", error);
                });
        },
    });

    function extractTime(createdAt) {
        return new Date(createdAt).toLocaleTimeString('en-US', { hour12: false });
    }


    const handleSort = (key) => {
        let direction = SORT_A;
        if (sortConfig.column === key && sortConfig.order === SORT_A) {
            direction = SORT_D;
        }
        setSortConfig({ column: key, order: direction });
    };

    const getConsultationDetail = (item) => {
        getAppointments({ appointment_id: item._id })
            .then((response) => {
                setConsultationHistoryDetails(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getSinglePatientHistory = (id) => {
        setOpenWithHeaderView(true);
        getPrescription({ history_id: id })
            .then((response) => {
                setPatientHistory(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const deleteRecord = (item) => {
        Swal.fire({
            title: t("center.header.msg_are_you_sure"),
            text: t("center.staff.btn_delete_text"),
            imageUrl: trash,
            showCancelButton: true,
            confirmButtonColor: "#dc3545",
            cancelButtonColor: "#6c757d",
            confirmButtonText: t("center.button.btn_delete"),
            cancelButtonText: t("center.button.btn_cancel"),
            reverseButtons: true,
            customClass: {
                popup: "swal-restaurant",
                confirmButton: "btn btn-danger col",
                cancelButton: "btn btn-secondary col",
            },
            allowOutsideClick: false,
        }).then((result) => {
            // if (result.isConfirmed) {
            //     globalLoader(true);
            //     deletePatient({ o_id: item._id })
            //         .then((response) => {
            //             globalLoader(false);
            //             if (response.success) {
            //                 Swal.fire({
            //                     icon: "success",
            //                     text: response.message,
            //                     ...SWAL_SETTINGS,
            //                 });
            //                 setRefreshList(!refreshList);
            //             } else {
            //                 Swal.fire({
            //                     icon: "error",
            //                     text: handleServerValidations(response),
            //                     ...SWAL_SETTINGS,
            //                 });
            //             }
            //         })
            //         .catch((error) => {
            //             globalLoader(false);
            //             console.log("deleteError");
            //         });
            // }
        });
    };

    useEffect(() => {
        getAllMedicine(ROLE.DOCTOR)
            .then((data) => {
                if (data && data.data) {
                    setMedicineData(data?.data || []);
                }
            })
            .catch((error) => {
                console.log("error ====> ", error);
            });
    }, [])


    const handelGenerateChart = (item) => {
        PatientDetails(item)
        .then((response) => {
            console.log("patent details--->",response?.data)
            navigate(`/doctor/patient/diet-chart/add?patient_id=${item?.patient_id}`, {
            state: { patientData: response?.data },
            });
        })
        .catch((err) => console.log("Error=====>", err))
    };

    const viewFunction = (item) => {
        navigate(`/doctor/consultation-history/view/${item._id}`,{ state: { tab: activeTab } })
    }



    return (
        <main id="main-content">
            <div className="mt-4 ms-3 me-3">
                <div className='dashboard-cards mb-4'>
                </div>
                <div className="card">
                    <div className="card-body">
                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link ${activeTab === "upcoming" ? "active" : ""}`}
                                    onClick={() => setActiveTab("upcoming")}
                                    type="button" role="tab">
                                    Upcoming Consultation
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link ${activeTab === "past" ? "active" : ""}`}
                                    onClick={() => setActiveTab("past")}
                                    type="button" role="tab">
                                    Past Consultation
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="pills-Credit" role="tabpanel"
                                aria-labelledby="pills-Credit-tab" tabindex="0">
                                <div className="table-responsive mt-2">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Patient ID</th>
                                                <th>Consultation ID</th>
                                                <th>{t("Doctor Name")}
                                                    <span style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>

                                                        <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'name' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '5px' }}></i>
                                                        <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'name' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '-8px' }} />
                                                    </span>
                                                </th>
                                                <th>{t("Patient Name")}
                                                    <span style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>

                                                        <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'name' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '5px' }}></i>
                                                        <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'name' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '-8px' }} />
                                                    </span>
                                                </th>
                                                <th>{t("Date")}
                                                    <span style={{ cursor: 'pointer' }} onClick={() => handleSort('date')}>

                                                        <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'date' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '5px' }}></i>
                                                        <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'date' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '-8px' }} />
                                                    </span>
                                                </th>
                                                <th>Time</th>
                                                <th>Major Concern</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {List?.length > 0 ? (
                                                List.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item?.patient_register_id ? '#'+(item?.patient_register_id) : '-'}</td>
                                                        <td>{item?.appointment_register_id ? '#'+(item?.appointment_register_id) : '-'}</td>
                                                        <td>{capitalizeFirstLetter(item?.doctor_name)}</td>
                                                    <td>{capitalizeFirstLetter(item?.patient_name) || '-'}</td>
                                                    {/* <td>{formatDateNew(item?.appointment_date)}</td> */}
                                                    <td>{formateDate(item?.appointment_date)}</td>
                                                    <td>{extractTime(item?.appointment_date)}</td>
                                                    {/* <td>{item?.start_time?.slice(0, 5)}</td> */}
                                                    <td>{capitalizeFirstLetter(TrimText(item?.major_concern,30))}</td>
                                                    <td className="">
                                                        <div className="dropdown ms-2">
                                                            <button className="btn btn-icon dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className="ti ti-dots-vertical"></i>
                                                            </button>
                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                <li>
                                                                    <a
                                                                        className="dropdown-item cp"
                                                                        onClick={() => { viewFunction(item) }}
                                                                    >
                                                                        <i className="ti ti-eye"></i>
                                                                        {t("center.button.btn_view")}
                                                                    </a>
                                                                </li>
                                                                {/* <li>
                                                                    <a
                                                                        className="dropdown-item cp"
                                                                        onClick={() => {
                                                                            deleteRecord(item);
                                                                        }}
                                                                    >
                                                                        <i className="ti ti-trash"></i>
                                                                        {t("center.button.btn_delete")}
                                                                    </a>
                                                                </li> */}
                                                                 <li>
                                                                    <a
                                                                        className="dropdown-item cp"
                                                                        // onClick={() => {
                                                                        //     navigate(`/doctor/patient/diet-chart/add?patient_id=${item?.patient_id}`, {
                                                                        //         state: { patientData: item },
                                                                        //     });
                                                                        // }}
                                                                        onClick={() => handelGenerateChart(item)}
                                                                    >
                                                                        <i className="ti ti-clipboard-list"></i>
                                                                        Generate Diet Chart
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={10} className="text-center">
                                                        <RecordNotFound />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-status-info d-flex justify-content-between align-items-center">
                                    <span>{t("center.staff.label_showing")} {offset + List.length} of {totalRecords} {t("center.staff.label_entries")}</span>
                                    <nav aria-label="Page navigation example" title={page}>
                                        {totalRecords && totalRecords > 0 ?
                                            <CustomPagination
                                                datalength={totalRecords}
                                                itemperpage={itemPerPage}
                                                currentPage={page}
                                                custompath="page"
                                                setPage={setPage}
                                                pageRoute={[{ name: "consultation", path: "/doctor/consultation-history" }]} /> : ""
                                        }
                                    </nav>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-Debit" role="tabpanel" aria-labelledby="pills-Debit-tab"
                                tabindex="0">
                                <div className="table-responsive mt-2">
                                <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Patient ID</th>
                                                <th>Consultation ID</th>
                                                <th>{t("Doctor Name")}
                                                    <span style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>

                                                        <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'name' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '5px' }}></i>
                                                        <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'name' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '-8px' }} />
                                                    </span>
                                                </th>
                                                <th>{t("Patient Name")}
                                                    <span style={{ cursor: 'pointer' }} onClick={() => handleSort('name')}>

                                                        <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'name' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '5px' }}></i>
                                                        <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'name' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '-8px' }} />
                                                    </span>
                                                </th>
                                                <th>{t("Date")}
                                                    <span style={{ cursor: 'pointer' }} onClick={() => handleSort('date')}>

                                                        <i className={`ti ti-arrow-narrow-up ${sortConfig.column === 'date' && sortConfig.order === SORT_D ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '5px' }}></i>
                                                        <i className={`ti ti-arrow-narrow-down ${sortConfig.column === 'date' && sortConfig.order === SORT_A ? 'sort-disabled' : ''}`}
                                                            style={{ marginLeft: '-8px' }} />
                                                    </span>
                                                </th>
                                                <th>Time</th>
                                                <th>Major Concern</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {List.map((item, index) => (
                                                <tr key={index}>
                                                    <td>#{item?.patient_register_id}</td>
                                                    <td>#{item?.appointment_register_id}</td>
                                                    <td>{capitalizeFirstLetter(item?.doctor_name)}</td>
                                                    <td>{capitalizeFirstLetter(item?.patient_name)}</td>
                                                    <td>{formateDate(item?.appointment_date)}</td>
                                                    <td>{extractTime(item?.appointment_date)}</td>
                                                    <td>{capitalizeFirstLetter(TrimText(item?.major_concern,30))}</td>
                                                    <td className="d-flex">
                                                        <div className="dropdown ms-2">
                                                            <button className="btn btn-icon dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className="ti ti-dots-vertical"></i>
                                                            </button>
                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                <li>
                                                                    <a
                                                                        className="dropdown-item cp"
                                                                        onClick={() => { viewFunction(item) }}
                                                                    >
                                                                        <i className="ti ti-eye"></i>
                                                                        {t("center.button.btn_view")}
                                                                    </a>
                                                                </li>
                                                                {/* <li>
                                                                    <a
                                                                        className="dropdown-item cp"
                                                                        onClick={() => {
                                                                            deleteRecord(item);
                                                                        }}
                                                                    >
                                                                        <i className="ti ti-trash"></i>
                                                                        {t("center.button.btn_delete")}
                                                                    </a>
                                                                </li> */}
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* add item modal */}
        </main>
    );
}